import { render, staticRenderFns } from "./cardTemplateVip04.vue?vue&type=template&id=6558a7e8&scoped=true&"
import script from "./cardTemplateVip04.vue?vue&type=script&lang=js&"
export * from "./cardTemplateVip04.vue?vue&type=script&lang=js&"
import style0 from "./cardTemplateVip04.vue?vue&type=style&index=0&id=6558a7e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6558a7e8",
  null
  
)

export default component.exports